import { createGlobalStyle } from "styled-components"

const AppGlobalStyles = createGlobalStyle`
  html {
    // overflow-y: hidden !important;
  }
`

export default AppGlobalStyles
